import React from "react";
import CustomButtton from "../../../components/Button/CustomButtton";
import { getImxIdToken } from "..";
import * as Realm from "realm-web";
//@ts-ignore
import { useRealmApp } from "../../../utils/RealmApp";
import { navigate } from "gatsby";
import { constants } from "../../../utils/constants";
import { useUiState } from "../../../context/UiContext";

interface IImxPassportProps {
  isRegister?: boolean;
  registerLogo?: any;
}

export const ImxPassport = ({ isRegister = false, registerLogo }: IImxPassportProps) => {
  const realmApp: Realm.App = useRealmApp();
  //global loader
  const {
    actions: { setIsLoading, showToast },
  } = useUiState();

  const onImxLogin = async () => {
    setIsLoading(true);
    try {
      const imxIdToken = await getImxIdToken();
      if (imxIdToken) {
        await realmApp.logIn(Realm.Credentials.jwt(imxIdToken));
        navigate(constants.app_routes.account);
      }
    } catch (e) {
      console.log("Error While Imx Login", e);
    }
    setIsLoading(false);
  };

  return (
    <div>
      {isRegister ? (
        <CustomButtton
          btnType="cyan"
          text="Create Account"
          icon1={registerLogo}
          btnSize="small"
          onClick={onImxLogin}
        />
      ) : (
        <CustomButtton text="Continue with IMX Passport" onClick={onImxLogin} />
      )}
    </div>
  );
};
